import { Box, Button, Heading, useDisclosure } from "@chakra-ui/react";
import { Trans } from "@lingui/macro";
import type { Brand } from "@src/__generated__/urql-graphql";
import { Card, CardHeader } from "@src/components/ui-kit";
import { Icon } from "@src/components/ui-kit/Icon";
import {
  AddTitle,
  ModalContactPerson,
} from "@src/components/widgets/Modals/ModalContactPerson";
import { can } from "@src/utils/components/permissions";
import { observer } from "mobx-react-lite";
import type React from "react";
import type { FC } from "react";
import SectionContact, { type SectionContactProps } from "./SectionContact";
import type { TContact, TContactExtended } from "./types";

interface CardContactPersonsProps {
  brand: Pick<Brand, "id" | "code" | "name">;
  contacts: TContactExtended[];
  onAddContact: (contact: TContact) => void;
  onUpdateContact: SectionContactProps["onUpdateContact"];
  onRemoveContact: SectionContactProps["onRemoveContact"];
}

const CardContactPersons: FC<
  React.PropsWithChildren<CardContactPersonsProps>
> = ({ brand, contacts, onAddContact, onUpdateContact, onRemoveContact }) => {
  const addContactModal = useDisclosure();

  return (
    <Box w="full">
      <CardHeader
        icon="user-02"
        title={
          <Heading size="md">
            <Trans>Contacts</Trans>
          </Heading>
        }
        action={
          can("brand_update") && (
            <Button
              ml="auto"
              colorScheme="grey"
              leftIcon={<Icon name="plus" />}
              onClick={addContactModal.onOpen}
              variant="outline"
            >
              <Trans>Add contact</Trans>
            </Button>
          )
        }
      />

      <Card.Section>
        {contacts.map((i) => (
          <SectionContact
            key={i.id}
            contact={i}
            onUpdateContact={onUpdateContact}
            onRemoveContact={onRemoveContact}
          />
        ))}
      </Card.Section>

      <ModalContactPerson
        {...addContactModal}
        title={<AddTitle brand={brand} />}
        brandId={brand.id}
        onSubmit={onAddContact}
      />
    </Box>
  );
};

export default observer(CardContactPersons);
